import {Component, inject, OnInit} from '@angular/core';
import {TableComponent} from "../../../global/components/table/table.component";
import {UserService} from "../../../global/services/user.service";
import {
    TableColumnFilterType,
    TableConfig,
    TableFieldAlignment,
    TableRowColorConditionOperator
} from "../../../global/components/table/table.interfaces";

@Component({
    selector: 'app-event-list',
    imports: [TableComponent],
    templateUrl: './event-list.component.html',
    styleUrl: './event-list.component.scss'
})
export class EventListComponent implements OnInit {

    private userService = inject(UserService);

    tableConfig!: TableConfig;

    ngOnInit(): void {
        this.tableConfig = {
            titleIcon: 'fas fa-location-crosshairs',
            title: 'Aktionen',
            openDatasetRouterLink: '/app/event/detail',
            enableCreate: this.userService.hasRight('MASTER_DATA_EDIT'),
            enableExportExcel: true,
            description: 'Automatisierte Aktionen können für bestimmte Ereignisse definiert werden.',
            dataConfig: {
                tableName: 'event_action',
                tableIndexName: 'EVAID',
                tableFields: [
                    {key: 'type', name: 'type', title: 'Ereignis', sortable: true, searchable: true, pipe: 'EventType'},
                    {key: 'action', name: 'action', title: 'Aktion', sortable: true, searchable: true, pipe: 'ActionType'},
                ],
                reverse: false,
                order: 'type',
                columnFilter: {
                    enabled: false,
                    fields: {
                        type: {value: '', type: TableColumnFilterType.INPUT},
                        action: {value: '', type: TableColumnFilterType.GROUP},
                    }
                }
            },
            localStorage: {
                version: 1,
                name: 'event-list',
                enabled: true
            },
            paginConfig: {
                id: 'eventList',
                rowFields: ['5', '10', '15', '20', '25', '30', '35', '40', '45', '50'],
                itemsPerPageDb: true,
                itemsPerPage: 10,
                currentPage: 1,
            }
        };
    }
}
